<template>
  <div class="vacancy">
    <router-link  v-if="route.path.includes('vacancies')" :to="`/vacancies${queryParams}`" class="vacancy__breadcrumbs">
      <img src="@/assets/images/icons/back-arrow.svg" alt="back">
      <p>Вакансии</p>
    </router-link>
    <router-link  v-if="route.path.includes('template')" :to="`/templates${queryParams}`" class="vacancy__breadcrumbs">
      <img src="@/assets/images/icons/back-arrow.svg" alt="back">
      <p>Шаблоны</p>
    </router-link>
    <h1 class="vacancy__title main-title">{{ fieldsVacancies?.vacancy?.title }}</h1>
    <div v-if="fieldsVacancies?.vacancy_owner_employee?.full_name" class="vacancy__author">Автор: {{ fieldsVacancies?.vacancy_owner_employee?.full_name }}</div>
    <div class="vacancy__row" v-if="!fieldsVacancies.vacancy">
      <div class="vacancy__wrapper container">
        <VSkeleton style="width: 832px" variants="CARD_CANDIDATE" v-if="skeleton"/>
        <VSkeleton style="width: 832px" variants="CARD_CANDIDATE_RESPONSE" v-if="skeleton"/>
      </div>
    </div>
    <div class="vacancy__row" v-if="fieldsVacancies.vacancy">
      <div class="vacancy__wrapper container">
        <MainBlock :vacancy="fieldsVacancies.vacancy" :actions="fieldsVacancies?.actions" class="vacancy__main-block"/>

        <div v-if="fieldsVacancies.vacancy.documents && fieldsVacancies.vacancy.documents.fields.length > 0" class="vacancy__documents">
          <VAccordion>
            <VerificationDocuments :documents="fieldsVacancies.vacancy.documents.fields" no-title/>


            <template #title>
              <div class="vacancy__docs-title">Запрашиваемые документы</div>
            </template>
          </VAccordion>
        </div>


        <div  class="vacancy__documents">
          <VAccordion>
            <VAddFiles v-if="documents_for_sign_in?.length > 0" set-padding="0"  v-model="documents_for_sign_in"
                       :valueIn="fieldsVacancies.vacancy?.documents_for_sign" delete-btn-disabled
                      no-preview divider/>
            <template #title>
              <div class="vacancy__docs-title">Файлы для подписания кандидатом</div>
            </template>
          </VAccordion>
        </div>

        <div style="padding: 0" class="vacancy__documents">
          <div class="flex space-between">
            <div style="padding: 24px 24px 8px 24px" class="vacancy__docs-title">Интеграция
              <img style="height: 24px;" src="@/assets/images/icons/avito.svg" alt="avito"/>
              Avito
            </div>
            <div class="flex gap-4 vacancy__integration-btn">
              <VButtonNew label="Привязать вакансию" style-type="link" @click="openLinkVacancyModal('avito')">
                <template #iconLeft>
                  <IconsPlus icon-size="20px" />
                </template>
              </VButtonNew>
            </div>
          </div>
            <IntegrationCardView title="Avito" v-if="integrationsData?.avito?.integrations?.length > 0" :items="integrationsData?.avito?.integrations"
                                 @delete="integrationsDelete" integration="avito-integrations"/>

          <div class="no-integration" v-if="integrationsData?.avito?.integrations?.length < 1">
            <div class="title">Интеграций нет</div>
            <div class="description">На данный момент нет интегрированных вакансий из Avito</div>
          </div>
        </div>

        <div style="padding: 0" class="vacancy__documents">
          <div class="flex space-between">
            <div style="padding: 24px 24px 8px 24px" class="vacancy__docs-title">Интеграция
              <img style="height: 24px;" src="@/assets/images/icons/hh.svg" alt="hh"/>
              HeadHunter
            </div>
            <div class="flex gap-4 vacancy__integration-btn">
              <VButtonNew label="Создать вакансию" style-type="link" @click="showPopupCreateHeadHunter = true">
                <template #iconLeft>
                  <IconsPlus icon-size="20px" />
                </template>
              </VButtonNew>
              <VButtonNew label="Привязать вакансию" style-type="link" @click="openLinkVacancyModal('hh')">
                <template #iconLeft>
                  <IconsPlus icon-size="20px" />
                </template>
              </VButtonNew>
            </div>
            </div>
            <IntegrationCardView title="HeadHunter" v-if="integrationsData?.hh?.integrations?.length > 0" :items="integrationsData?.hh?.integrations"
                                 @delete="integrationsDelete" integration="hh-integrations"/>

          <div class="no-integration" v-if="integrationsData?.hh?.integrations?.length < 1">
            <div class="title">Интеграций нет</div>
            <div class="description">На данный момент нет интегрированных вакансий из HeadHunter</div>
          </div>
        </div>

        <VButtonNew label="Опубликовать вакансию" class="vacancy__publish" clickEffect v-if="!fieldsVacancies.vacancy.is_published &&
            route.meta.type === 'vacancy' && !!(!!fieldsVacancies?.actions?.save_draft || !!fieldsVacancies?.actions?.save_vacancy)
            " @click="publish"/>

        <VButtonNew label="Создать вакансию" class="vacancy__publish" clickEffect v-if="!fieldsVacancies.vacancy.is_published &&
            route.meta.type === 'template'" link :to="`/templates/${vacancyId}/create`"/>
      </div>

      <ActionsMenu class="vacancy__actions-menu"
                   :specialityName="vacancy.title"
                   :isPublished="fieldsVacancies.vacancy.is_published"
                   :isEdit="!!fieldsVacancies?.actions.save_vacancy || !!fieldsVacancies?.actions.save_draft"/>
    </div>

    <ModalWindow v-if="showPopupErrorModal" @close="showPopupErrorModal = false" class="vacancy__modal">
      <VacancyErrorModal @close="showPopupErrorModal = false" title="Вакансия <br> не опубликована"
                         description="Проверьте правильность заполненных данных"/>
    </ModalWindow>

    <ModalWindow  v-if="showPopupCreateHeadHunter" @close="showPopupCreateHeadHunter = false" class="vacancy__modal-poups">
      <VModalWrapper @close="showPopupCreateHeadHunter = false" hidden-btn flexRow :line-header="true" height="90vh" title="Создание вакансии на HeadHunter" width="832px">
        <CreateHeadHunter :vacancy-id="route.params.id"  @cancel="showPopupCreateHeadHunter = false" />
      </VModalWrapper>
    </ModalWindow>

    <ModalWindow v-if="linkVacancyModal" @close="integrationClose" class="vacancy__modal-add-integration">
      <VModalWrapper
          hidden-btn
          @close="integrationClose"
          :title="`Привязка вакансии с ${linkVacancyType === 'avito' ? 'Авито' : 'HeadHunter'}`"
          width="100%"
      >
        <VIntegrationField
            v-model="formIntegration.vacancy_id"
            class=" w-full"
            :placeholder="linkVacancyType === 'avito' ? 'Выберите вакансию с авито*' : 'Выберите вакансию с hh*'"
           :itegrationType="linkVacancyType"
        />
        <VManagerField
            class=" w-full"
            placeholder="Выберите менеджера для вакансии*"
            v-model="formIntegration.hr_id"
            :disabled="!formIntegration.vacancy_id"
        />
        <VButtonNew label="Добавить" @click="addIntegration" />
        <VButtonNew style-type="grey" label="Отменить" @click="integrationClose" />
      </VModalWrapper>
    </ModalWindow>

    <AccessClosed v-if="vacancy.blocked_by_contract"/>
  </div>
</template>

<script setup>
import {computed, onActivated, onDeactivated, onMounted, ref} from "vue";
import {useRouter, useRoute} from "vue-router";

import VacancyErrorModal from "@/components/ModalWindow/ModalBodyes/VacancyErrorModal";
import vacancies from "@/api/vacancies";
import ActionsMenu from "@/components/VacancyDetailCard/ActionsMenu";
import MainBlock from "@/components/VacancyDetailCard/MainBlock";
import IntegrationCardView from "@/components/Integration/IntegrationCardView";
import VerificationDocuments from "@/components/VacancyDetailCard/VerificationDocuments";
import AccessClosed from "@/components/AccessClosed"
import VAccordion from "@/components/UI/VAccordion/index.vue";
import VSkeleton from "@/components/UI/VSkeleton/index.vue";
import VAddFiles from "@/components/UI/VAddFiles.vue";
import VButtonNew from "@/components/UI/VButtonNew/index.vue";
import IconsPlus from "@/components/Icons/Plus.vue";
import CreateHeadHunter from "@/components/CreateVacancy/CreateHeadHunter.vue";
import VModalWrapper from "@/components/UI/VModalWrapper.vue";
import ModalWindow from "@/components/ModalWindow/index.vue";
import VIntegrationField from "@/components/UI/DataFields/VIntegrationField/index.vue";
import VManagerField from "@/components/UI/DataFields/VManagerField/index.vue";

const linkVacancyModal = ref(false)
const linkVacancyType = ref('')
const openLinkVacancyModal = (type) => {
  linkVacancyModal.value = true;
  linkVacancyType.value = type;
}

const formIntegration = ref({
  vacancy_id: '',
  hr_id: ''
})

const route = useRoute();
const router = useRouter();

const skeleton = ref(true)
const vacancyId = ref(route.params.id);

const vacancy = ref({});
const fieldsVacancies = ref({});
const documents_for_sign_in = ref([]);

const getFieldsVacancies = async () => {
  try {
    // fieldsVacancies.value = await vacancies.getFieldsVacancies({
    //     vacancy_id: vacancyId.value,
    // });
    fieldsVacancies.value = await vacancies.getFieldsVacancies(vacancyId.value);
    fieldsVacancies.value?.vacancy?.documents_for_sign?.forEach((e) => {
      documents_for_sign_in.value.push(e.id);
    })
    if(fieldsVacancies.value) skeleton.value = false
  } catch (error) {
    console.log(error);
  }
};

const showPopupErrorModal = ref(false);
const showPopupCreateHeadHunter = ref(false);
const publish = async () => {
  try {
    await vacancies.createVacancies(vacancyId.value);
    await router.push("/vacancies");
  } catch (error) {
    showPopupErrorModal.value = true;
    console.log(error);
  }
};

const queryParams = computed(() => {
  const searchParams = new URLSearchParams();

  for (const [key, value] of Object.entries(route.query)) {
    if (value !== undefined && value !== null) {
      searchParams.append(key, value);
    }
  }
  return '?' + searchParams.toString()
})

const integrationsData = ref({
  avito: [],
  hh: []
})

const integrationsUpdate = async () => {
  try {
    integrationsData.value.hh = await vacancies.getIntegration(vacancyId.value, "hh-integrations");
    integrationsData.value.avito = await vacancies.getIntegration(vacancyId.value, "avito-integrations");
  } catch (error) {
    console.log(error);
  }
}
const integrationClose = async () => {
  linkVacancyModal.value = false
  formIntegration.value = {
    vacancy_id: '',
    hr_id: ''
  }
}

const integrationsDelete = async (integration, integrationId) => {
  await vacancies.deleteIntegration(vacancyId.value, integration, integrationId);
  await integrationsUpdate();
}

const addIntegration = async () => {
  if (linkVacancyType.value === 'avito') {
    await vacancies.addIntegration(vacancyId.value, "avito",
        {hr_id: formIntegration.value?.hr_id, avito_vacancy_id: formIntegration.value?.vacancy_id.toString()},
    );
  } else {
    await vacancies.addIntegration(vacancyId.value, "hh",
        {hr_id: formIntegration.value?.hr_id, hh_vacancy_id: formIntegration.value?.vacancy_id.toString()}
    );
  }
  await integrationsUpdate()
  await integrationClose()
}


onActivated(async () => {
  window.scrollTo(0, -10000)
  vacancyId.value = await route.params.id
  await getFieldsVacancies();
  await integrationsUpdate();
});

onDeactivated(async () => {
  vacancy.value = {}
  fieldsVacancies.value = {}
})
</script>

<style scoped lang="scss">
.vacancy {
  padding-bottom: 30px;

  &__breadcrumbs {
    margin-top: 12px;
    display: flex;
    align-items: center;
    color: #8F9CAC;
    text-decoration: none;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    user-select: none;

    p {
      margin-left: 4px;
      font-size: 14px;
      font-weight: 400;
    }
  }

  &__title {
    margin-top: 8px;
  }

  &__author {
    font-size: 14px;
    font-weight: 500;
    color: $dark-blue;
    margin-top: 8px;
  }

  &__row {
    margin-top: 24px;
    display: flex;
    align-items: flex-start;
  }

  &__actions-menu {
    margin-left: 32px;
  }

  &__questionnaire-block {
    margin-top: 24px;
  }

  &__extended-questionnaire-block {
    margin-top: 24px;
  }

  &__publish {
    width: 437px;
    margin-top: 24px;
  }

  &__modal {
    &::v-deep(.modal__body) {
      width: 304px;
    }
  }

  &__header {
    &::v-deep(.v-breadcrumbs) {
      .v-breadcrumbs__item:nth-child(2) .v-breadcrumbs__arrow {
        display: none !important;
      }
    }
  }

  &__documents {
    width: 100%;
    margin-top: 24px;
    padding: 24px;
    border-radius: 16px;
    background-color: #fff;
    box-shadow: 2px 2px 8px 0 rgba(0, 0, 0, 0.0392156863);
  }

  &__docs-title {
    font-weight: 500;
    font-size: 20px;
    line-height: 24.2px;
    display: flex;
    gap: 8px;
  }

  &__integration-btn {
    padding-top: 8px;
    padding-right: 24px;
    .v-button {
      font-weight: 500;
      font-size: 14px;
      line-height: 100%;
      letter-spacing: 0;
      padding: 4px;
      text-align: right;
    }
  }
  &__modal-add-integration {
    &::v-deep(.modal__body) {
      width: 477px;
      height: auto;
      border-radius: 16px;
    }
  }

  &__modal-poups {
    &::v-deep(.modal__body) {
      width: auto;
      height: auto;
      border-radius: 16px;
    }
  }
}

.no-integration {
  height: 132px;
  padding: 32px;
  margin-top: 24px;
  color: $grey-pressed;
  .title {
    font-weight: 600;
    margin-bottom: 8px;
    font-size: 16px;
    line-height: 100%;
    letter-spacing: 0;
    text-align: center;
  }

  .description {
    font-weight: 400;
    font-size: 14px;
    line-height: 100%;
    letter-spacing: 0%;
    text-align: center;

  }
}
</style>
